import { useState } from "react";
import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBView
} from "mdbreact";
import Carousel from "./OfferCarousel";

const CarouselPage = ({ images }) => {
  let [open, setOpen] = useState(false);
  let [curIndex, setCurIndex] = useState();

  return (
    <>
      <MDBCarousel
        style={{
          height: 400,
          overflow: "hidden"
        }}
        activeItem={1}
        length={images.length}
        showControls={true}
        showIndicators={true}
        className="z-depth-1"
      >
        <MDBCarouselInner>
          {images.map((image, i) => (
            <MDBCarouselItem itemId={i + 1} key={i}>
              <MDBView
                onClick={() => {
                  setOpen(true);
                  setCurIndex(i);
                }}
                className="moz-p-offer__image-item"
              >
                <img
                  alt="Slika ponude"
                  className="d-block loop"
                  style={{
                    maxHeight: 400
                  }}
                  src={image}
                />
              </MDBView>
            </MDBCarouselItem>
          ))}
        </MDBCarouselInner>
      </MDBCarousel>
      <Carousel
        open={open}
        setOpen={setOpen}
        images={images}
        curIndex={curIndex}
      />
    </>
  );
};

export default CarouselPage;
